import { Form, Row, Col, FormInstance } from 'antd';

import {
  AccountPayableReleaseFormValues,
  Installment,
} from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import CardAccountPayable from './CardAccountPayable';
import AccountPayableDetailHeader from './AccountPayableDetailHeader';
import ReleaseForm from '..';

interface Props {
  form: FormInstance<AccountPayableReleaseFormValues>;
  installment?: Installment;
  isEdit?: boolean;
}

function ReleaseDetailForm({ form, installment, isEdit }: Props) {
  return (
    <>
      <Form layout="vertical" form={form} name="accountPayableGeneralForm">
        <Row gutter={[16, 9]}>
          <Col span={24}>
            <CardAccountPayable installment={installment} form={form} />
          </Col>
        </Row>

        {isEdit && <AccountPayableDetailHeader />}

        <ReleaseForm form={form} isEdit={isEdit} installment={installment} />
      </Form>
    </>
  );
}

export default ReleaseDetailForm;
